import { VREditorSubPanel } from './subpanel';
import { CAUI, ColorPicker, FieldLabel } from 'ca-ui';

export class VREditorWelcomePanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'welcome',
      name: 'Welcome',
      preview: true,
      initialAsset: vr.options.welcomePerson !== undefined ? vr.options.welcomePerson.assetDetails : vr.assets.people[0],
      assets: vr.assets.people,
      addApplyAssetButton: true,
      addApplyAssetMessage: '',
      assetSelectLabel: 'Welcome Person',
      onAssetChange: function (asset) {
        if (this.getObject()) this.getObject().setAsset(asset);
        this.setSelectedWelcomePerson(asset, `https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/people/person_${asset.id}_day_${CAUI.zeroPad(0, 2)}.png`);
        this.preview.css(
          'background-image',
          'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/people/person_' +
              asset.id +
              '_day_' +
              CAUI.zeroPad(
                0,
                2
              ) +
              '.png'
        );
      },
      onCreateAssetItem: function (item, asset) {
        item.css(
          'background-image',
          'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/people/person_' +
              asset.id +
              '_day_' +
              CAUI.zeroPad(
                0,
                2
              ) +
              '.png'
        );
      }
    });
    this.vr = vr;
    this.panelOpts.assets = vr.assets.people;
    this.panelOpts.id = 'welcome';
    this.panelOpts.name = 'Welcome';
    this.id = 'welcome';
    this.name = 'Welcome';
    this.initSelect();
    this.initPreview();
    this.showPreview(true);
    $(document).ready(function () {
      $('#popup_list.ca-welcome_popup-selector').change(function () {
        console.log('change called');
        this.popupDropdownList = $('#popup_list.ca-welcome_popup-selector').children('option');
        const welcomeLabel = $('label[for="ca-vr_editor-controls_show_welcome"]');
        const showPersonLabel = $('label[for="ca-vr_editor-controls_display_person"]');
        console.log(welcomeLabel);
        if (this.popupDropdownList.length > 0 && this.popupDropdownList.val() !== 'none') {
          this.welcomePopupChanged($('#popup_list.ca-welcome_popup-selector').val());
          console.log('show welcome label');
          welcomeLabel.show();
          showPersonLabel.show();
          this.editorShowWelcome.show();
          this.editorDisplayPerson.show();
          this.previewContainer.show();
          this.typeLabel.show();
        } else {
          console.log('hide welcome label');
          welcomeLabel.hide();
          showPersonLabel.hide();
          this.editorShowWelcome.hide();
          this.editorDisplayPerson.hide();
          this.previewContainer.hide();
          this.typeLabel.hide();
        }
      }.bind(this));

      $('#popup_list.ca-welcome_popup-selector').blur(function () {
        console.log('welcome panel no longer has focus');
        this.welcomePopupChanged($('#popup_list.ca-welcome_popup-selector').val());
      }.bind(this));
      // eslint-disable-next-line no-undef
      this.preview.css('background-image', `url(${vr.options.welcomePerson.imgSrc}?p=thumb)`);

      this.addPopupBtnWelcome = $('#popup_list.ca-welcome_popup-selector').siblings('#add_popup');
      this.editPopupBtnWelcome = $('#popup_list.ca-welcome_popup-selector').siblings('#edit_popup');
      this.addPopupBtnWelcome.on('click', function () {
        this.getPopupContent($('#popup_list.ca-welcome_popup-selector').val(), true);
      }.bind(this));

      this.editPopupBtnWelcome.on('click', function () {
        this.getPopupContent($('#popup_list.ca-welcome_popup-selector').val(), true);
      }.bind(this));

      if (vr.options.welcomeContent !== undefined && vr.options.welcomeContent !== null) {
        if (vr.options.welcomeContent.id !== undefined) {
          this.setSelectedWelcomePopup();
        }
      }
    }.bind(this));
  }

  initControls () {
    // popup selection drop down
    const popupSelectionDropdown = $(`<label for='popup_list'>Select a popup</label>
    <select id='popup_list' class="ca-welcome_popup-selector" name='popup_list'></select>`);

    super.append(popupSelectionDropdown);

    this.editorShowWelcome = super.createEditorCheckbox(
      'show_welcome',
      'Show Welcome'
    );
    // set show welcome value to whatever the vr scene show welcome is, IF it's defined
    this.editorShowWelcome.change(function () {
      this.setShowWelcome();
    }.bind(this));

    // eslint-disable-next-line no-undef
    $(this.editorShowWelcome).prop('checked', vr.options.showWelcome);

    // add popup button
    const addPopupButton = $('<button id="add_popup">New Popup</button>');
    super.append(addPopupButton);

    // edit popup button
    const editPopupButton = $('<button id="edit_popup">Edit Popup</button>');
    super.append(editPopupButton);

    this.welcomePopupErrorMessage = $('<div class="ca-ui-action_errormessage"></div>');
    super.append(this.welcomePopupErrorMessage);
    this.welcomePopupErrorMessage.hide();

    // add checkbox for display person
    this.editorDisplayPerson = super.createEditorCheckbox(
      'display_person',
      'Display Person at Welcome Screen'
    );
    this.editorDisplayPerson.change(function () {
      this.setShowPerson();
    }.bind(this));

    // eslint-disable-next-line no-undef
    $(this.editorDisplayPerson).prop('checked', vr.options.showWelcomePerson);

    // Enter Room text input
    this.CTALabel = $('<label style="margin-top:20px">Enter Room Text</label>');
    super.append(this.CTALabel);

    this.CTATextbox = $('<input type="input" maxlength="100" />');
    // eslint-disable-next-line no-undef
    vr.options.welcomeCTAtext !== undefined ? this.CTATextbox.val(vr.options.welcomeCTAtext) : this.CTATextbox.val('');
    this.CTATextbox.on(
      'input',
      function () {
        this.setWelcomeCTAText(this.CTATextbox.val());
      }.bind(this)
    );
    super.append(this.CTATextbox);

    this.colorContainer = new FieldLabel({ label: 'Welcome Button Colour' });
    super.append(this.colorContainer.el);

    this.colorPicker = new ColorPicker({
      color: 'red',
      onSelect: function (color) {
        this.setWelcomeCTAButtonColour(color);
      }.bind(this)
    });

    this.colorContainer.setField(this.colorPicker);

    if (this.vr.options.welcomeContent !== undefined && this.vr.options.welcomeContent !== null && this.vr.options.welcomeContent.id) {
      this.getPopupContent(this.vr.options.welcomeContent.id);
    }
  }

  setWelcomeCTAButtonColour (colourValue) {
    if (this.vr.options.welcomeCTAButtonColour === undefined) {
      this.vr.options.welcomeCTAButtonColour = '';
    }

    this.vr.options.welcomeCTAButtonColour = colourValue;

    // inject colour directly into cta button here using css, for initial view
    const welcomeCTAButton = $('.ca-ui-vrwelcomepopup-enterbutton');
    welcomeCTAButton.css('background-color', colourValue);
  }

  setWelcomeCTAText (text) {
    this.vr.options.welcomeCTAtext = this.vr.options.welcomeCTAtext || '';

    this.vr.options.welcomeCTAtext = text;

    // inject text directly into cta button using html() for initial view
    const welcomeCTAButton = $('.ca-ui-vrwelcomepopup-enterbutton');
    welcomeCTAButton.text(text);
  }

  setShowWelcome () {
    if (this.vr.options.showWelcome === undefined) {
      this.vr.options.showWelcome = false;
    }
    this.vr.options.showWelcome = !this.vr.options.showWelcome;
  }

  setShowPerson () {
    if (this.vr.options.showWelcomePerson === undefined) {
      this.vr.options.showWelcomePerson = false;
    }

    this.vr.options.showWelcomePerson = !this.vr.options.showWelcomePerson;
  }

  setSelectedWelcomePopup () {
    this.selectedPopupToUse = this.vr.options.welcomeContent.id;
    $('#popup_list.ca-welcome_popup-selector').find(`option#${this.vr.options.welcomeContent.id}`).attr('selected', true);
    if (this.vr.options.welcomeContent.metadata.length === 0) {
      this.triggerUnpublishedWarningMessage();
    } else {
      this.welcomePopupErrorMessage.text('');
      this.welcomePopupErrorMessage.hide();
    }
  }

  setSelectedWelcomePerson (asset, img) {
    if (this.vr.options.welcomePerson === undefined) {
      this.vr.options.welcomePerson = {
        assetDetails: '',
        imgSrc: ''
      };
    }
    this.vr.options.welcomePerson.assetDetails = asset;
    this.vr.options.welcomePerson.imgSrc = img;
  }

  welcomePopupChanged (popupId) {
    this.getPopupContent(popupId, true);
  }

  getPopupContent (popupId, isSaving) {
    if (isSaving) {
      this.vr.showLoading('Setting welcome popup...');
    }
    $.ajax({
      url: `${this.editor.apiUrl}/contents/${popupId}`,
      headers: {
        Authorization: 'Bearer ' + this.editor.authToken,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
      .done(function (data) {
        // set welcomepopup data to the data returned
        if (this.vr.options.welcomeContent !== undefined) {
          this.vr.options.welcomeContent = data.data;
        } else {
          this.vr.options.welcomeContent = {};
          this.vr.options.welcomeContent = data.data;
        }
        this.setSelectedWelcomePopup();
      }.bind(this))
      .fail((e) => {
        if (e.responseJSON) {
          console.log('welcome panel id doesnt exist');
          this.vr.options.welcomeContent = null;
          this.vr.options.setShowWelcome = false;
          this.vr.options.setShowPerson = false;
          this.vr.hideLoading();
        }
      })
      .always(function () {
        this.vr.hideLoading();
      }.bind(this));
    return null;
  }

  triggerUnpublishedWarningMessage () {
    this.welcomePopupErrorMessage.html('<p>We have a little problem. Your popup selection has failed. Please select a published popup and save the changes in the room. Be aware if you save with an unpublished popup, it will not display at the Welcome Screen.</p>');
    this.welcomePopupErrorMessage.show();
  }

  // override
  openPanel(){}
}
